export type TFontOptions = {label: string; value: string};
export type TMode = 'font-size' | 'font-family';

export enum ETargetAutoFill {
    SUBJECT = 'subject',
    EDITOR = 'editor'
}
